import { Funnel } from "@phosphor-icons/react"
import {
  Button,
  Checkbox,
  FilterDrawer,
  FormGroup,
  FormQuerySelector,
  FormSelector,
  QuerySelector,
  RadioGroup,
} from "@vesatogo/grass-core"
import { DateInput } from "@vesatogo/grass-dates"
import { Dispatch, SetStateAction, useState } from "react"
import { PRODUCTION_TRADE_STATUS } from "~/constants/ProductionTradeStatus"
import {
  useAllCommoditiesQuery,
  useAllVarietiesQuery,
  useUsersQuery,
} from "~/generated/graphql"
import { ProductionFilterType } from "."

type ProductionFilterProps = {
  filter: ProductionFilterType
  setFilter: Dispatch<SetStateAction<ProductionFilterType>>
}
const ProductionFilter = ({ filter, setFilter }: ProductionFilterProps) => {
  const [isOpen, setOpen] = useState(false)

  function inputProps(path: string) {
    return {
      value: filter[path],
      onChange: (e: any) => {
        setFilter(prev => ({
          ...prev,
          [path]: e?.target ? e.target.value : e,
        }))
      },
    }
  }

  function getAppliedFilters(prefix: string, filter: any) {
    const totalApplied = Object.keys(filter)?.filter?.(
      key => key.startsWith(prefix) && filter[key]
    )?.length
    return totalApplied ? `${totalApplied} Applied` : null
  }
  return (
    <>
      <Button
        onClick={() => {
          setOpen(prev => !prev)
        }}
        variant={Object.values(filter)?.length > 0 ? "solid" : "outline"}
        className="items-center"
      >
        <Funnel />
      </Button>
      <FilterDrawer
        tabs={[
          {
            id: 1,
            title: "Buyer",
            subtitle: getAppliedFilters("sb", filter),
            content: (
              <>
                <FormGroup label="Buyer" className={"mb-2"} helperText="buyer">
                  <QuerySelector
                    serverSideQuery
                    dataHook={useUsersQuery}
                    variables={{ groups: ["Trader"] }}
                    {...inputProps("sb_buyer")}
                  />
                </FormGroup>
              </>
            ),
          },
          {
            id: 2,
            title: "Commodity",
            subtitle: getAppliedFilters("com", filter),
            content: (
              <div className="flex flex-col gap-3">
                {" "}
                <FormGroup label="Commodity" className={"w-full"}>
                  <QuerySelector
                    serverSideQuery
                    dataHook={useAllCommoditiesQuery}
                    {...inputProps("com_commodity")}
                  />
                </FormGroup>{" "}
                <FormGroup label="Variety" className={"w-full"}>
                  <QuerySelector
                    dataHook={useAllVarietiesQuery}
                    variables={{ commodity_id: filter.com_commodity?.id }}
                    {...inputProps("com_variety")}
                  />
                </FormGroup>{" "}
              </div>
            ),
          },
          {
            id: 3,
            title: "Others",
            subtitle: getAppliedFilters("oth", filter),
            content: (
              <div className="flex flex-col gap-3">
                <RadioGroup
                  className={"w-full"}
                  label="Mode *"
                  {...inputProps("oth_mode")}
                >
                  <Checkbox type={"radio"} value="direct" label="Direct" />
                  <Checkbox
                    type={"radio"}
                    value="facilitator"
                    label="Via Facilitator"
                  />
                </RadioGroup>
                <FormSelector
                  label="Status"
                  options={Object.values(PRODUCTION_TRADE_STATUS)?.map(
                    item => ({
                      id: item?.id,
                      name: item?.label,
                    })
                  )}
                  {...inputProps("oth_status")}
                />

                <FormGroup label="Created At" className={"w-full"}>
                  <DateInput
                    className={"w-full"}
                    {...inputProps("oth_created_at")}
                  />
                </FormGroup>
                <FormGroup label="Production Start" className={"w-full"}>
                  <DateInput
                    className={"w-full"}
                    {...inputProps("oth_production_start")}
                  />
                </FormGroup>
                {/* <FormQuerySelector
                  label="Placed By"
                  serverSideQuery
                  dataHook={useUsersQuery}
                  variables={{
                    groups: ["Trader"],
                  }}
                  {...inputProps("oth_placed_by")}
                /> */}
              </div>
            ),
          },
        ]}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onApply={() => {
          setOpen(false)
        }}
        onClearAll={() => {
          setFilter({})
          setOpen(false)
        }}
      />
    </>
  )
}

export default ProductionFilter
